import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as Cross } from '../../../../../assets/icons/cross.svg'
import Button from '../../../../../components/Button/Button'
import Modal from '../../../../../components/Modal'
import { WP_REST_API_Post } from 'wp-types/index'
import parse from 'html-react-parser'
import ApplicationNoteForm from '../../../../Resources/components/ApplicationNote/ApplicationNoteForm'
import ApplicationNoteDetails from '../../../../Resources/components/ApplicationNote/ApplicationNoteDetails'
import api from '../../../../../utils/api'
import { twMerge } from 'tailwind-merge'
import { debounce } from '../../../../../utils/helpers'

interface DetailsFormProps {
  close: () => void
  post: WP_REST_API_Post
}

const DetailsForm = ({ close, post }: DetailsFormProps) => {
    const formRef = useRef<HTMLDivElement>(null)
    const articleRef = useRef<HTMLDivElement>(null)
    const [makeFormScrollable, setMakeFormScrollable] = useState(false)

    useEffect(() => {
        const calculateHeight = () => {
            if (formRef.current && articleRef.current) {
                const height = formRef.current.clientHeight
                articleRef.current.style.height = `${height}px`
                setMakeFormScrollable(height > window.innerHeight)
            }
        }
        calculateHeight()
        const calculateHeightDebounced = debounce(calculateHeight, 10)
        window.addEventListener('resize', calculateHeightDebounced)
        return () => {
            window.removeEventListener('resize', calculateHeightDebounced)
        }
    }, [formRef, articleRef])

    const openFile = () => {
    // @ts-ignore
        api.get(`/wp-json/wp/v2/media/${post.acf['application_note']}`).then((response) => {
            window.open(response.data['source_url'], '_blank')
        })
    }

    return (
        <Modal close={close} className='xl:mx-16 2xl:mx-0'>
            <div className='flex md:flex-row flex-col xl:max-w-screen-xl md:max-w-screen-lg overflow-y-scroll md:overflow-y-visible no-scrollbar max-h-[95vh] mx-auto'>
                <ApplicationNoteDetails
                    post={post}
                    articleRef={articleRef}
                    classes={{
                        outer: 'p-6 pr-2 md:p-12 md:pr-4 bg-sand md:w-1/2',
                        inner: 'max-h-[400px] mt-14 md:mt-0 md:max-h-full',
                        scroll: 'py-6 px-2 mt-14 md:mt-0 md:py-12 md:px-4 h-full',
                    }}
                >
                    <h3 className='mb-8'>{parse(post.title.rendered)}</h3>
                </ApplicationNoteDetails>
                <div className={twMerge('bg-white p-6 md:p-12 w-screen md:w-1/2 min-w-fit')}>
                    <div className={twMerge('mx-auto h-full flex items-center md:w-max')}>
                        <Button
                            outerClasses='absolute right-1/2 translate-x-full md:translate-x-0 md:right-0 top-0 m-4 border-black/20'
                            innerClasses='p-4'
                            onClick={close}
                        >
                            <Cross className='w-3.5 h-3.5' />
                        </Button>
                        <ApplicationNoteForm
                            onSubmit={openFile}
                            className='overflow-y-scroll h-max no-scrollbar'
                            formRef={formRef}
                            style={{ height: makeFormScrollable ? '100%' : undefined }}
                            id={post.slug}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default DetailsForm
